import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
} from '@angular/core';
import {
    LookupFieldResult,
    LookupObject,
    UTILS_ICON_DELETE,
    WdxDestroyClass,
} from '@wdx/shared/utils';
import { MoleculeInfoCardModule } from '../../../../components/molecules/molecule-info-card/molecule-info-card.module';
import { InfoCardData } from '../../../../models/info-card-data.model';
import {
    WdxButtonStyle,
    WdxButtonSize,
    WdxButtonModule,
} from '@wdx/shared/components/wdx-button';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxStopPropagationDirective } from '@wdx/shared/components/wdx-stop-propagation';
import { InfoCardService } from '../../../services/info-card/info-card.service';

@Component({
    selector: 'clmi-lookup-selected-items',
    templateUrl: './lookup-selected-items.component.html',
    styleUrls: ['./lookup-selected-items.component.scss'],
    imports: [
        MoleculeInfoCardModule,
        WdxIconModule,
        WdxStopPropagationDirective,
        WdxButtonModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLookupSelectedItemsComponent extends WdxDestroyClass {
    public infoCardService = inject(InfoCardService);

    @Input() lookupCards: InfoCardData[];
    @Input() set rows(value: Array<LookupFieldResult | LookupObject>) {
        if (value) {
            this.lookupCards =
                this.infoCardService.lookupResultsAsInfoCardData(value);
        }
    }
    @Input() disabled = false;

    @Output() deleteItem = new EventEmitter<InfoCardData>();

    readonly WdxButtonStyle = WdxButtonStyle;
    readonly WdxButtonSize = WdxButtonSize;
    readonly UTILS_ICON_DELETE = UTILS_ICON_DELETE;
}
